import { useContext, useState } from 'react';

import { ViewContext } from '@/state/contexts';
import { toggleFullscreen } from '@/util/fullscreen';
import { logg } from '@/util/logg';

import ActionButton from './ActionButton';
import MusicController from './MusicController';

const MetaCluster = () => {
	const [uiState, setUiState] = useState(0);

	logg('shuffleUI: ' + uiState);
	const {
		changeCamera,
		camState,
		setCamState,

		toggleVerboseUI,
		verboseUI,
		toggleTicker,
		showTicker,
		setShowSettingsModal,

		minimize,
		toggleMinimize,

		verboseSettings,
		toggleVerboseSettings,
	}: any = useContext(ViewContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	const shuffleUI = () => {
		if (uiState === 0 || uiState === 2) {
			toggleVerboseUI();
		} else {
			toggleVerboseUI();
			toggleTicker();
		}

		setUiState((prev) => {
			if (prev >= 3) {
				return 0;
			}
			return prev + 1;
		});
	};

	function getUiStateName() {
		switch (uiState) {
			case 0:
				return 'Full';
			case 1:
				return 'Ticker';
			case 2:
				return 'Meta';
			default:
				return 'Empty';
		}
	}

	return (
		<div className="butt-right">
			<div className="butt-right-div">
				<ActionButton
					leftEmoji={'👀'}
					leftText={verboseSettings && 'Hide'}
					onClickFunc={() => {
						toggleVerboseSettings();
					}}
				/>

				{minimize === true && (
					<ActionButton
						leftEmoji="➖↩️"
						leftText="Un-Minimize"
						onClickFunc={() => {
							toggleMinimize();
						}}
					/>
				)}

				<MusicController />

				{/*
				<ActionButton
					leftEmoji="↕️"
					leftText="Zoom"
					onClickFunc={() => {
						toggleFullscreen();
					}}
				/>
				*/}

				<ActionButton
					leftEmoji={'ℹ️'}
					leftText={'UI'}
					rightText={getUiStateName()}
					onClickFunc={() => {
						shuffleUI();
					}}
				/>

				<ActionButton
					leftEmoji={'📜'}
					leftText={'Settings'}
					onClickFunc={() => {
						setShowSettingsModal(true);
					}}
				/>
			</div>

			<div className="butt-right-cam">
				<p>📸</p>
				<button
					onClick={() => {
						setCamState('player');
					}}
					disabled={camState === 'player'}
				>
					1
				</button>
				<button
					onClick={() => {
						setCamState('payment');
					}}
					disabled={camState === 'payment'}
				>
					2
				</button>
				<button
					onClick={() => {
						setCamState('overhead');
					}}
					disabled={camState === 'overhead'}
				>
					3
				</button>
			</div>
		</div>
	);
};

export default MetaCluster;
